import Web3 from "web3";

let initState = {
  userWalletAddress: "",
  web3: new Web3(Web3.givenProvider || "http://localhost8545"),
  salesContract: null,
  data: [],
};

export const UserReducer = (state = initState, action) => {
  const { type, payload } = action;

  switch (type) {
    case "USER_WALLET_ADDRESS":
      return {
        ...state,
        userWalletAddress: payload,
      };

    case "IOD_DATA":
      return {
        ...state,
        data: payload,
      };
    case "DISCONNECT":
      return {
        ...state,
        userWalletAddress: "",
        bnbBalance: 0,
      };
    case "WEB3":
      return {
        ...state,
        web3: payload,
      };

    case "CONTRACT":
      return {
        ...state,
        contract: payload,
      };
    case "BNB_BALANCE":
      return {
        ...state,
        bnbBalance: payload,
      };

    case "NETWORK":
      return {
        ...state,
        network: payload,
      };

    case "SALES_CONTRACT":
      return {
        ...state,
        salesContract: payload,
      };

    default:
      return state;
  }
};
